<template>
  <div class="app">
    <div class="parameter-wrap">
      <!-- <h2>优筑家三维施工图外链上传</h2>
            <div class="link-input">
                <input placeholder="请输入优筑家施工图链接~" v-model="sThirdParty"/>
            </div> -->

      <div class="upload-wrap">
        <ul>
          <li
            @click="changeTab(index)"
            :class="{ active: index == nTabIndex }"
            v-for="(item, index) in arrTab"
            :key="index"
          >
            {{ item.name }}
          </li>
        </ul>
        <div class="img-box">
          <img
            v-if="arrTab[nTabIndex].url"
            :src="arrTab[nTabIndex].url"
            :review="arrTab[nTabIndex].name"
            :alt="arrTab[nTabIndex].name"
          />
          <div class="tip" v-if="!arrTab[nTabIndex].url">
            <h3>上传文件</h3>
            <p>点击这里上传图纸<br />支持拓展名：.png.jpg···</p>
          </div>
          <input
            type="file"
            accept="image/*"
            class="uploadImage"
            @change="imgChange($event, 1)"
            style="opacity: 0"
          />
          <div
            class="del"
            @click="del(nTabIndex)"
            v-show="arrTab[nTabIndex].url"
          ></div>
        </div>
      </div>
      <div class="btn-wrap">
        <div class="skip" @click="skip">跳过</div>
        <div class="next" @click="submit">方案书生成</div>
      </div>
    </div>
    <!-- 确认删除弹窗 -->
    <div class="mask" @touchmove.prevent v-if="bConfirmPopupShow">
      <div class="confirm-popup">
        <div class="popup-close" @click.stop="bConfirmPopupShow = false"></div>
        <div class="confirm-content">
          <p>是否进行裁剪?</p>
        </div>
        <div class="confirm-btn">
          <button @click.stop="popupCancle()">取消</button>
          <button @click.stop="popupConfirm()">确定</button>
        </div>
      </div>
    </div>
    <image-cropper
      ref="cropper"
      hide-input
      :option="oCropper"
      @getbase64Data="uploadImage"
    ></image-cropper>
  </div>
</template>

<script>
import oForm from "@/js/form.js";
import imageCropper from "vue-cropper-h5";
import oCommon from "@/libsV2/common.js";
export default {
  components: {
    imageCropper,
  },
  created() {
    $init(() => {
      this.$store.commit("loadSwitch", false);
    });
  },
  data() {
    return {
      sWaddImgUrl: "", //三维图地址
      arrTab: [
        { name: "冷暖顶面图", url: "", local_url: "", type: 0 },
        { name: "采暖地面图", url: "", local_url: "", type: 1 },
        { name: "水系统图", url: "", local_url: "", type: 2 },
        { name: "新风系统图", url: "", local_url: "", type: 3 },
      ], //设计图纸分类
      nTabIndex: 0, //设计图纸分类索引
      oCropper: {
        outputSize: 0.5,
        canScale: true,
        fixedNumber: [4, 3],
        original: false,
        confirmButtonBackgroundColor: "#2c7aec",
      }, //裁剪插件配置
      sThirdParty: "", //第三方，3D预览图链接地址

      bConfirmPopupShow: false,
      oFile: null,
    };
  },
  methods: {
    // 删除当前上传图纸
    del(index) {
      this.arrTab[index].url = "";
      this.arrTab[index].local_url = "";
    },
    // 切换图纸分类
    changeTab(index) {
      this.nTabIndex = index;
    },
    sWimgChange(e, num) {
      // this.bConfirmPopupShow = true
      this.oFile = e;
      this.typeNum = num;
      // this.$refs.cropper.loadFile(this.oFile.target.files[0]);
      this.popupCancle();
    },
    imgChange(e, num) {
      this.bConfirmPopupShow = true;
      //  console.log(e);
      this.oFile = e;
      this.typeNum = num;
      // let file = e.target.files[0];
      // let size = files.size/(1024*1024);
      // if(size > 10){  // 10M
      //     this.$toast('上传的图片过大！')
      //     return false
      // }
    },
    popupConfirm() {
      this.bConfirmPopupShow = false;
      this.$refs.cropper.loadFile(this.oFile.target.files[0]);
    },
    async popupCancle() {
      this.bConfirmPopupShow = false;
      const sBase64 = await oCommon.upImgCompression(this.oFile);
      let data = {
        file: sBase64[0],
      };
      if (this.typeNum == 1) {
        data.qr_code = 0;
      } else if (this.typeNum == 0) {
        data.qr_code = 1;
      }
      this.$store.commit("loadSwitch", true);
      oForm.uploadImg(data).then((res) => {
        this.$store.commit("loadSwitch", false);
        if (this.typeNum == 1) {
          this.arrTab[this.nTabIndex].url = res.data.data.result.media_url;
          this.arrTab[this.nTabIndex].local_url =
            res.data.data.result.local_url;
          this.$previewRefresh();
        } else if (this.typeNum == 0) {
          this.sWaddImgUrl = res.data.data.result.media_url;
          if (res.data.data.result.qr_code == "") {
            this.$toast("未检测出图片中是否有二维码");
          }
          this.sThirdParty = res.data.data.result.qr_code;
        }
      });
    },
    // 上传图片
    uploadImage(sBase64) {
      this.$store.commit("loadSwitch", true);
      let data = {
        file: sBase64,
      };
      if (this.typeNum == 1) {
        data.qr_code = 0;
      } else if (this.typeNum == 0) {
        data.qr_code = 1;
      }
      this.$store.commit("loadSwitch", true);
      oForm.uploadImg(data).then((res) => {
        this.$store.commit("loadSwitch", false);
        if (this.typeNum == 1) {
          this.arrTab[this.nTabIndex].url = res.data.data.result.media_url;
          this.arrTab[this.nTabIndex].local_url =
            res.data.data.result.local_url;
          this.$previewRefresh();
        } else if (this.typeNum == 0) {
          this.sWaddImgUrl = res.data.data.result.media_url;
          if (res.data.data.result.qr_code == "") {
            this.$toast("未检测出图片中是否有二维码");
          }
          this.sThirdParty = res.data.data.result.qr_code;
        }
      });
    },
    // 跳过
    skip() {
      this.$router.replace(
        "/ant/scheme?reportId=" + this.$store.state.nAntReportId
      );
    },
    submit() {
      // if(!this.$store.state.nAntReportId){
      //     this.$toast('报告id错误！')
      //     return false
      // }
      let oData = {
        report_id: this.$store.state.nAntReportId,
        third_img: this.sThirdParty,
        third_img_url: this.sWaddImgUrl,
      };
      let arrAttach = [];
      this.arrTab.forEach((it) => {
        if (it.local_url) {
          arrAttach.push({
            img: it.local_url,
            type: it.type,
          });
        }
      });
      /* 如果上传图纸，或者第三方图纸，需调用提交提交接口,  都没得话则跳过 */
      if (arrAttach.length || oData.third_img) {
        oData.attach = JSON.stringify(arrAttach);
        this.$store.commit("loadSwitch", true);
        oForm.reportAttach(oData).then((res) => {
          this.$store.commit("loadSwitch", false);
          this.$router.replace("/ant/scheme?reportId=" + oData.report_id);
        });
      } else {
        this.$router.replace("/ant/scheme?reportId=" + oData.report_id);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./index.scss";
</style>
